// extracted by mini-css-extract-plugin
export var social = "bZ_hq";